// extracted by mini-css-extract-plugin
export default {"confirmationContent":"IssueDeletionConfirmationDialog-module__confirmationContent__Ful3g_F","confirmationList":"IssueDeletionConfirmationDialog-module__confirmationList__iV_yFZE"};